export const SCROLL_CONTAINER_ID = "app-scroll";

export const getScrollContainer = () =>
  document.getElementById(SCROLL_CONTAINER_ID);
